import HelpDeskIcon from "components/shared/svg/HelpDeskIcon";
import PropTypes from "prop-types";
import { Header, Icon, Title } from "./CategoryHeader.styled";

export default function CategoryHeader({ categorySlug, title }) {
    return (
        <Header>
            <Icon>
                <HelpDeskIcon
                    categorySlug={categorySlug}
                    width={48}
                    height={48}
                />
            </Icon>
            <Title>{title}</Title>
        </Header>
    );
}

CategoryHeader.propTypes = {
    categorySlug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
};
